export default __webpack_public_path__ + "static/media/rare.a45a7db4.png";